<script setup lang="ts">
defineOptions({
	name: 'IconHansHeart',
})

interface Props {
	class?: string
	classIcon?: string
}

const props = withDefaults(defineProps<Props>(), {
	class: 'text-neutral-50',
	classIcon: 'w-8 h-8',
})
</script>

<template>
	<svg
		:class="[props.class, props.classIcon]"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M8.06789 26.4012H5.58789C4.89789 26.4012 4.33789 25.8412 4.33789 25.1512V17.6512C4.33789 16.9612 4.89789 16.4012 5.58789 16.4012H8.06789C8.75789 16.4012 9.31789 16.9612 9.31789 17.6512V25.1512C9.31789 25.8412 8.75789 26.4012 8.06789 26.4012Z"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.7879 21.4012H19.6929C20.2317 21.4012 20.7554 21.2262 21.1867 20.9012L24.1942 18.6362C24.9454 18.0712 25.9954 18.1462 26.6592 18.8125V18.8125C27.3954 19.5525 27.3954 20.7512 26.6592 21.49L24.0792 24.0812C23.3842 24.7787 22.4992 25.255 21.5342 25.4487L17.8854 26.1812C17.1629 26.3262 16.4167 26.3087 15.7004 26.1287L12.4017 25.3012C12.0079 25.2012 11.6017 25.1512 11.1942 25.1512H9.3179"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			d="M16.7879 21.4012H18.6366C19.6779 21.4012 20.5229 20.5537 20.5229 19.5075V19.1287C20.5229 18.26 19.9341 17.5025 19.0941 17.2925L16.2404 16.5762C15.7767 16.46 15.3004 16.4012 14.8229 16.4012V16.4012C13.6692 16.4012 12.5404 16.7437 11.5804 17.3875L9.3179 18.9012"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
		<path
			fill-rule="evenodd"
			clip-rule="evenodd"
			d="M19.6954 4.72746L19.2591 5.19371L18.8216 4.72746C17.8629 3.70496 16.2729 3.62121 15.2129 4.53621V4.53621C14.1291 5.47121 14.0004 7.09246 14.8916 8.21496C16.1666 9.81996 17.6279 11.405 19.2591 12.6512C20.9316 11.3737 22.4241 9.74121 23.7216 8.09496C24.5641 7.02621 24.3904 5.47496 23.3629 4.58621L23.3154 4.54496C22.2454 3.62121 20.6541 3.70496 19.6954 4.72746V4.72746Z"
			stroke="currentColor"
			stroke-width="1.91884"
			stroke-linecap="round"
			stroke-linejoin="round"
		/>
	</svg>
</template>
